import * as React from "react";
import { useEffect, useState } from "react";
import ScrollBar from "react-perfect-scrollbar";
import { connect } from "react-redux";
import { ScrollOptions } from "../../constants/ScrollOptions";
import { IdStyles } from "../../less/IdStyles";
import { selectCoop, selectCoopMessage, selectCoopRole, selectCurrentCoopLevel, } from "../../selectors/selectCoopInfo";
import { ButtonSecondarySquareSmall } from "../generic/common/ButtonSecondarySquareSmall";
import { Icon } from "../generic/icon/Icon";
import { IdIcon } from "../generic/icon/IdIcon";
import { actionUpdateCoopMessage } from "./actionCoop";
import { CoopEventNotices } from "./CoopEventNotices";
import { CoopInfoProfile } from "./info-view/CoopInfoProfile";
import { IdCoopRole } from "./info-view/IdCoopRole";
import { MessageBoardEdit } from "./MessageBoardEdit";
export var _TabCoopMessageBoard = React.memo(function (_a) {
    var coop = _a.coop, coopMessage = _a.coopMessage, coopLevel = _a.coopLevel, onUpdateMessage = _a.onUpdateMessage, role = _a.role;
    if (coop == undefined) {
        return React.createElement(React.Fragment, null);
    }
    var currentMessage = coopMessage ? coopMessage : "";
    var _b = useState(currentMessage), message = _b[0], setMessage = _b[1];
    var creationTime = coop.creationTime;
    var _c = useState(false), isMessageEditMode = _c[0], setIsMessageEditMode = _c[1];
    var toggleMessageEditMode = function () {
        setIsMessageEditMode(!isMessageEditMode);
    };
    var handleSave = function () {
        onUpdateMessage(message);
        toggleMessageEditMode();
    };
    useEffect(function () {
        currentMessage = coopMessage ? coopMessage : "";
        setMessage(currentMessage);
    }, [coopMessage]);
    var getMessageSection = function () {
        if (isMessageEditMode) {
            return (React.createElement(MessageBoardEdit, { message: message, handleSave: handleSave, setMessage: setMessage }));
        }
        else {
            return (React.createElement(React.Fragment, null,
                React.createElement(ScrollBar, { component: "div", options: ScrollOptions, className: "w100" },
                    React.createElement("p", { className: IdStyles.TextNormal + " margin--small overflow-break-word" }, message)),
                React.createElement("div", { className: "flex__align-end padding--small" }, getCoopMessageEditButton())));
        }
    };
    var getCoopMessageEditButton = function () {
        return role === IdCoopRole.Leader || role === IdCoopRole.Deputy ? (React.createElement(ButtonSecondarySquareSmall, { onClick: function () { return toggleMessageEditMode(); } },
            React.createElement("div", { className: "flex flex--guts w100 h100" },
                React.createElement(Icon, { icon: IdIcon.SettingsIcn, styleId: IdStyles.IconSmall })))) : (undefined);
    };
    return (React.createElement("div", { className: "flex flex--stacked flex--aligned flex--around w100 h100" },
        React.createElement("div", { className: "flex w100 flex--around flex--aligned " + IdStyles.CoopNoticeInfoContainer },
            React.createElement(CoopInfoProfile, { level: coopLevel, creationTime: creationTime }),
            React.createElement("div", { className: IdStyles.CoopInfoDescriptionLargeContainer + " flex flex--spaced" }, getMessageSection())),
        React.createElement(CoopEventNotices, null)));
});
var mapState = function (state) { return ({
    coop: selectCoop(state),
    coopLevel: selectCurrentCoopLevel(state),
    coopMessage: selectCoopMessage(state),
    role: selectCoopRole(state),
}); };
var mapDispatch = function (dispatch) { return ({
    onUpdateMessage: function (message) { return dispatch(actionUpdateCoopMessage(message)); },
}); };
export var TabCoopMessageBoard = connect(mapState, mapDispatch)(_TabCoopMessageBoard);



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/TabCoopMessageBoard.tsx
// module id = 2615
// module chunks = 3